import { render, staticRenderFns } from "./ProfileModal.vue?vue&type=template&id=6e4a5491&"
import script from "./ProfileModal.vue?vue&type=script&lang=js&"
export * from "./ProfileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports